import React, { useState } from "react";
import "../App.css";

import img1 from "../static/mobile/1.png";
import img2 from "../static/mobile/2.png";
import img3 from "../static/mobile/3.png";
import img4 from "../static/mobile/4.png";
import img5 from "../static/mobile/5.png";
import img6 from "../static/mobile/6.png";
import img7 from "../static/mobile/7.png";
import img8 from "../static/mobile/8.png";
import img9 from "../static/mobile/9.png";
import img10 from "../static/mobile/10.png";
import img11 from "../static/mobile/11.png";

type MobileSlideKey =
    | "main"
    | "schedule"
    | "lk"
    | "notifications"
    | "design"
    | "orders-view"
    | "order-details"
    | "payment"
    | "companies"
    | "booking"
    | "feedback";

interface Slide {
    id: number;
    key: MobileSlideKey;
    title: string;
    image: string;
}

interface Feature {
    key: MobileSlideKey;
    label: string;
}

const slides: Slide[] = [
    {
        id: 1,
        key: "main",
        title: "Привлекающая главная страница",
        image: img1,
    },
    {
        id: 2,
        key: "schedule",
        title: "Расписание поставок",
        image: img2,
    },
    {
        id: 3,
        key: "lk",
        title: "Личный кабинет клиента",
        image: img3,
    },
    {
        id: 4,
        key: "notifications",
        title: "Push-уведомления",
        image: img4,
    },
    {
        id: 5,
        key: "design",
        title: "Индивидуальный дизайн",
        image: img5,
    },
    {
        id: 6,
        key: "orders-view",
        title: "Удобное отображение заказов",
        image: img6,
    },
    {
        id: 7,
        key: "order-details",
        title: "Просмотр и редактирование заказов",
        image: img7,
    },
    {
        id: 8,
        key: "payment",
        title: "Онлайн-оплата",
        image: img8,
    },
    {
        id: 9,
        key: "companies",
        title: "Добавление компаний",
        image: img9,
    },
    {
        id: 10,
        key: "booking",
        title: "Запись на поставки",
        image: img10,
    },
    {
        id: 11,
        key: "feedback",
        title: "Форма обратной связи",
        image: img11,
    },
];

const features: Feature[] = [
    { key: "main", label: "Привлекающая главная страница" },
    { key: "schedule", label: "Расписание поставок" },
    { key: "lk", label: "Личный кабинет клиента" },
    { key: "notifications", label: "Push-уведомления" },
    { key: "design", label: "Индивидуальный дизайн" },
    { key: "orders-view", label: "Удобное отображение заказов" },
    { key: "order-details", label: "Просмотр и редактирование заказов" },
    { key: "payment", label: "Онлайн-оплата" },
    { key: "companies", label: "Добавление компаний" },
    { key: "booking", label: "Запись на поставки" },
    { key: "feedback", label: "Форма обратной связи" },
];

interface MobileAppProps {
    onOpenModal: (type: "order" | "consult") => void;
}

const MobileApp: React.FC<MobileAppProps> = ({ onOpenModal }) => {
    const [activeSlideIndex, setActiveSlideIndex] = useState<number>(0);

    const handleFeatureClick = (key: MobileSlideKey) => {
        const index = slides.findIndex((s) => s.key === key);
        if (index !== -1) {
            setActiveSlideIndex(index);
        }
    };

    const nextSlide = () => {
        setActiveSlideIndex((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setActiveSlideIndex((prev) =>
            prev === 0 ? slides.length - 1 : prev - 1
        );
    };

    return (
        <>
            {/* Hero — крупный блок для приложения */}
            <section className="hero-section">
                <div className="hero-text">
                    <p className="hero-tag">Приложение</p>
                    <h1>Мобильное приложение для вашего фулфилмента</h1>
                    <p className="hero-subtitle">
                        Статусы заказов, поставки, уведомления и оплата — в смартфоне клиента.
                        Приложение, которое продолжает ваш сервис на iOS и Android.
                    </p>
                    <div className="hero-actions">
                        <button
                            className="hero-primary-btn"
                            onClick={() => onOpenModal("order")}
                        >
                            Заказать приложение
                        </button>
                        <button
                            className="hero-secondary-link"
                            type="button"
                            onClick={() => onOpenModal("consult")}
                        >
                            <span className="link-text">Получить консультацию</span>
                        </button>
                    </div>
                </div>
                <div className="hero-accent-card">
                    <p className="hero-accent-title">
                        Фулфилмент всегда под рукой
                    </p>
                    <p className="hero-accent-text">
                        Клиент видит статусы отправок, получает push-уведомления
                        и управляет поставками прямо из приложения. Меньше звонков —
                        больше прозрачности.
                    </p>
                </div>
            </section>

            {/* Phone + Features */}
            <section className="features-section">
                <div className="features-left">
                    <div className="phone-mockup">
                        <div className="phone-inner">
                            <div className="phone-notch" />
                            <div className="phone-screen">
                                <div
                                    className="slides-wrapper slides-wrapper--phone"
                                    style={{
                                        transform: `translateX(-${activeSlideIndex * 100}%)`,
                                    }}
                                >
                                    {slides.map((slide) => (
                                        <div className="slide slide--phone" key={slide.id}>
                                            <div className="slide-image-wrapper slide-image-wrapper--phone">
                                                <img
                                                    src={slide.image}
                                                    alt={slide.title}
                                                    className="slide-image"
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="features-right">
                    <h2>Что будет в вашем приложении?</h2>
                    <ul className="feature-list">
                        {features.map((f, idx) => {
                            const slideIndex = slides.findIndex((s) => s.key === f.key);
                            const isActive = slideIndex === activeSlideIndex;
                            return (
                                <li key={f.key}>
                                    <button
                                        type="button"
                                        className={
                                            "feature-item" +
                                            (isActive ? " feature-item--active" : "")
                                        }
                                        onClick={() => handleFeatureClick(f.key)}
                                    >
                                        <span className="feature-bullet"></span>
                                        <span className="feature-label">{f.label}</span>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </section>
        </>
    );
};

export default MobileApp;
